const Resources = {

    table_headers: [
        {
            text:   'Walking#',
            value:  'walking_number',
            type:   'link',
        },
        { 
            text:   'Description',
            value:  'description',
            type:   'link',
            with_icon: true,
            src_icon: '/assets/img/svg/customdescriptionicon.svg',
        },
        { 
            text:   'Minutes',
            value:  'daily_minutes'
        },
        { 
            text:   'Sq.Feet',
            value:  'sq_ft'
        },
        {   
            text:   'DailyTask(s)',
            value:  'daily_tasks',
            type: 'tasks'
        },
        {   
            text:   'PolicingTask(s)',
            value:  'policing_tasks',
            type:   'tasks',
            class:  'header-blu',
        },
        {   
            text:   'ProjectTask(s)',
            value:  'project_task',
            type:   'tasks',
            class:  'header-orange',
        },
    ],

    breadcrumb:[
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Buildings',
            href:   '/buildings',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Rooms',
            href:   '/building-rooms',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Rooms - Advanced search',
            href:   '/building-rooms-advanced-search',
            arrow:  "",
        },
    ],

    boolean_options:[
        {
            id:     true,
            name:   'Yes',
        },
        {
            id:     false,
            name:   'No',
        },
    ],

    excl_options:[
        {
            id:     true,
            name:   'Yes',
        },
        {
            id:     false,
            name:   'No',
        },
    ],

    simbol_options:[
        {
            id:     1,
            name:   '=',
        },
        {
            id:     2,
            name:   '<',
        },
        {
            id:     3,
            name:   '>',
        },
    ],

    shift_criteria_options:[
        {
            id:     1,
            name:   'All selected shifts',
        },
        {
            id:     2,
            name:   'Any selected shifts',
        },
    ],

}

export default Resources